export const START_REF = "start"
export const ABOUT_REF = "about"
export const RESUME_REF = "resume"
export const PROJECTS_REF = "projects"
export const LINKDN_URL =
  "https://www.linkedin.com/in/jos%C3%A9-manuel-crist%C3%B3bal-flores-766621122/"
